module.exports = __webpack_public_path__ + "static/devops-c36fccc34351666a18c177901a45ab77.svg";